import { useEffect, useMemo } from "react";

export const RenderPDF = ({ fileBlob }: { fileBlob: Blob }) => {
  const objectUrl = useMemo(() => URL.createObjectURL(fileBlob), [fileBlob]);

  useEffect(() => {
    return () => URL.revokeObjectURL(objectUrl);
  }, [objectUrl]);

  return <iframe className="blob-to-image h-full w-full" src={objectUrl}  />;
};
